import {
  object,
  string,
  number,
  date,
  InferType,
  boolean,
  oneOf,
  mixed,
  array,
} from "yup";
export const validations = {
  text: {
    required: string()
      .trim() // Remove leading and trailing whitespace
      .matches(/^[A-Za-z\u0370-\u03FF\u1F00-\u1FFF\s]+$/, {
        // don't allow special characters and numbers
        message: "Not allowed special characters and numbers",
        excludeEmptyString: true,
      })
      .required("Field is required"),
    notRequired: string().matches(/^[A-Za-z\u0370-\u03FF\u1F00-\u1FFF\s]+$/, {
      message: "Not allowed special characters and numbers",
      excludeEmptyString: true,
    }),
  },
  select: string()
    .matches(/^(?!.*\bSelect collection\b).*$/, "Field is required")
    .required("Field is required"),
  selectSubject: string()
    .matches(/^(?!.*\bSelect subject\b).*$/, "Field is required")
    .required("Field is required"),
  titleSelect: string()
    .matches(/^(?!.*\bTitle\b).*$/, "Field is required")
    .required("Field is required"),
  email: string().email("Invalid email address").required("Email is required"),
  requiredInput: string().required("Field is required"),
  //   phone: string()
  //     .required("Phone number is required")
  //     .matches(/^\d+$/, "Phone number must contain only numbers") // Only digits
  //     .length(10, "Phone number must be exactly 10 digits"),
  title: string()
    .required("Field is required")
    .oneOf(["Mr", "Ms"], "Field is required"),
  dayOfBirth: string()
    .matches(/^(?!.*\bDay\b).*$/, "Field is required")
    .required("Field is required"),
  monthOfBirth: string()
    .matches(/^(?!.*\bMonth\b).*$/, "Field is required")
    .required("Field is required"),
  yearOfBirth: string()
    .matches(/^(?!.*\bYear\b).*$/, "Field is required")
    .required("Field is required"),
  atSlcFrom: string()
    .matches(/^(?!.*\bYear\b).*$/, "Field is required")
    .required("Field is required"),
  atSlcUntil: string()
    .test("atSlcUntil", "Until value must be larger than from", (value) => {
      if (+atSlcFrom.value <= +atSlcUntil.value) {
        return true;
      } else {
        return false;
      }
    })
    .matches(/^(?!.*\bYear\b).*$/, "Field is required")
    .required("Field is required"),

  checkRequired: boolean().oneOf([true], "Required"),
  phone: string()
    .matches(/^(\+?\d+(\s\d+)*)?$/, "Check your phone number")
    .required("Phone number is required"),
  personalOptions: array()
    .of(string().oneOf(["Blue", "Green", "Red"])) // Ensures valid values
    .min(1, "You must select at least one option.") // At least one selection
    .required("This field is required."),
};
